export default "__VITE_ASSET__Col5Ign0__"